import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { Anchor, Box, Image, Skeleton, Stack, Text, useMantineTheme, } from "@mantine/core";
import { getMintPageUrl } from "../../../config";
import { useBuilderGetPublicCollectionQuery } from "../builder.graphql.generated";
export const CollectionCard = (props) => {
    const { collectionId, tokenId, aspectRatio, design = "default" } = props;
    const hasTokenId = tokenId !== "";
    const theme = useMantineTheme();
    const { data, loading, error } = useBuilderGetPublicCollectionQuery({
        variables: {
            collectionId,
            tokenId: tokenId,
            skipToken: hasTokenId === false,
        },
    });
    const collection = data === null || data === void 0 ? void 0 : data.getPublicCollection;
    const token = collection === null || collection === void 0 ? void 0 : collection.seriesToken;
    // const data = null;
    // const loading = false;
    // const error = new Error("Not implemented");
    // console.log("CollectionCard", { collectionId, data, loading, error });
    if (loading || error || collection == null) {
        return _jsx(CollectionCardSkeleton, { ...props, error: error });
    }
    const image = token != null ? token.imageUrl : collection.collectionImage;
    const title = token != null ? `#${token.tokenId}` : collection.name;
    const subtitle = token != null ? collection.name : null;
    const mintUrl = getMintPageUrl(collection);
    const body = (() => {
        if (design === "default") {
            return (_jsx(Box, { sx: {
                    padding: "16px 0",
                }, children: _jsxs(Stack, { spacing: 2, children: [_jsx(Text, { fw: 500, children: title }), subtitle != null && (_jsx(Text, { fw: 500, fz: 14, c: "dimmed", children: subtitle }))] }) }));
        }
        return null;
    })();
    return (_jsx(Anchor, { href: mintUrl, target: "_blank", underline: false, w: "100%", h: "100%", children: _jsxs(Stack, { spacing: 0, children: [_jsx(Box, { sx: {
                        aspectRatio,
                        overflow: "hidden",
                        width: "100%",
                        minWidth: 0,
                        borderRadius: 8,
                        backgroundColor: theme.colors.gray[3],
                    }, children: _jsx(Image, { height: "100%", fit: "contain", src: image, alt: collection.name, styles: {
                            root: {
                                width: "100%",
                                height: "100%",
                            },
                            figure: {
                                width: "100%",
                                height: "100%",
                            },
                            imageWrapper: {
                                width: "100%",
                                height: "100%",
                            },
                            image: {
                                width: "100%",
                                height: "100%",
                            },
                        } }) }), body] }) }));
};
const CollectionCardSkeleton = (props) => {
    const { tokenId, aspectRatio, design = "default", error } = props;
    const hasTokenId = tokenId !== "";
    if (error != null) {
        console.error("CollectionCardSkeleton", error);
    }
    const body = (() => {
        if (design === "default") {
            return (_jsx(Box, { sx: {
                    padding: "16px 0",
                }, children: _jsxs(Stack, { spacing: 2, children: [_jsx(Skeleton, { h: 22 }), hasTokenId && _jsx(Skeleton, { h: 20 })] }) }));
        }
        return null;
    })();
    return (_jsx(Box, { children: _jsxs(Stack, { spacing: 0, children: [_jsx(Skeleton, { sx: {
                        aspectRatio,
                        overflow: "hidden",
                        width: "100%",
                        minWidth: 0,
                    } }), body] }) }));
};
